<template>
  <div>
    <el-form ref="partFormRef" :model="partFormModel" class="flex-gap-4">
      <div
        class="part-table-info-item-wrapper"
        v-for="(partItem, partIndex) in partFormModel.partInfoList"
        :key="partIndex"
      >
        <div class="part-table-info-header">
          <p>
            <span class="part-title-bold"
              >（{{ partIndex + 1 }}/{{ partInfoList.length }}）{{
                partItem.name
              }}
            </span>
            <span class="unit-class" style="margin-left: 12px;"
              >单位：{{ partItem.quoteUnitStr }}</span
            >
          </p>
          <div class="tag-list-box">
            <span class="tag-item" v-if="partItem.subCategoryStr">{{
              partItem.subCategoryStr
            }}</span>
            <span class="tag-item" v-if="partItem.materialStr">{{
              partItem.materialStr
            }}</span>
            <span class="tag-item" v-if="partItem.materialProviderStr"
              >材料提供方：{{ partItem.materialProviderStr }}</span
            >
            <span class="tag-item" v-if="partItem.annualUsage"
              >年用量预估：{{ partItem.annualUsage | thousands }}</span
            >
            <span class="tag-item" v-if="partItem.targetUnitPrice"
              >目标采购单价：{{ detailInfo.currencySymbol
              }}{{ partItem.targetUnitPrice | priceFormat }}</span
            >
          </div>
        </div>
        <div class="part-table-content-box">
          <el-image
            :src="`${partDrawingUrl}${partItem.partThumbnailsHashCode}`"
            class="quote-image"
            :onerror="`this.src='${defaultRfqThn}'`"
            @click="viewDrawing(partItem)"
          ></el-image>
          <el-table
            :data="partFormModel.partInfoList[partIndex].partPriceInfoList"
            style="width: 100%"
            @cell-mouse-enter="handleMouseEnter"
          >
            <el-table-column prop="numQuantity" label="报价数量">
              <template #default="scope">
                {{ scope.row.numQuantity | thousands }}
              </template>
            </el-table-column>
            <el-table-column prop="num1" :align="isEdit ? 'left':'right'">
              <template #header>
                <span>单价</span>
                <span class="red-text" v-if="isEdit">*</span>
              </template>
              <template #default="scope">
                <el-form-item
                  :prop="`partInfoList.${partIndex}.partPriceInfoList.${scope.$index}.num1`"
                  :rules="formRules.num2"
                  :show-message="false"
                >
                  <el-input-number
                    v-if="isEdit"
                    v-model="scope.row.num1"
                    :controls="false"
                    :min="0"
                    @blur="handleInputBlur(scope.row, 'num1', $event, 4)"
                  ></el-input-number>
                  <span v-else>{{detailInfo.currencySymbol}}{{ scope.row.num1 }}</span>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="num2" label="模具费" :align="isEdit ? 'left':'right'">
              <template #default="scope">
                <el-input-number
                  v-if="isEdit"
                  v-model="scope.row.num2"
                  :controls="false"
                  :min="0"
                  @blur="handleInputBlur(scope.row, 'num2', $event, 2)"
                ></el-input-number>
                <span v-else>{{detailInfo.currencySymbol}}{{ scope.row.num2 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="num3" label="杂费" :align="isEdit ? 'left':'right'">
              <template #default="scope">
                <el-input-number
                  v-if="isEdit"
                  v-model="scope.row.num3"
                  :controls="false"
                  :min="0"
                  @blur="handleInputBlur(scope.row, 'num3', $event, 2)"
                ></el-input-number>
                <span v-else>{{detailInfo.currencySymbol}}{{ scope.row.num3 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="num4" label="运费" :align="isEdit ? 'left':'right'">
              <template #default="scope">
                <el-input-number
                  v-if="isEdit"
                  v-model="scope.row.num4"
                  :controls="false"
                  :min="0"
                  @blur="handleInputBlur(scope.row, 'num4', $event, 2)"
                ></el-input-number>
                <span v-else>{{detailInfo.currencySymbol}}{{ scope.row.num4 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="total" label="报价总额" :align="'right'">
              <template #default="scope">
                <span class="rowTotalClass">
                  {{ scope.row.partRowTotal }}
                </span>
                <!-- {{partItem['partPriceInfoList'][scope.$index]['partRowTotal']}} -->
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-form>
    <partPriceInfo
      :detailInfo="detailInfo"
      :priceTotalResult="formatPriceTotal"
      :isEdit="isEdit"
    ></partPriceInfo>
  </div>
</template>

<script>
import partPriceInfo from './part-price-info.vue'
import Big from 'big.js'
import { companyLogoUrl } from '@/utils/config.js'
import { getOnlineDrawing } from '@/utils/api/zhenyunOrder'
import { onlineUrl, partDrawingUrl } from '@/utils/config'
import {mapMutations,mapState} from 'vuex'
export default {
  components: {
    partPriceInfo,
  },
  name: 'part-table-info',
  props: {
    isEdit: {
      type: Boolean,
      default: true,
    },
    partInfoList: {
      type: Array,
      default: () => [],
    },
    detailInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      partDrawingUrl,
      tableRowIndex1: undefined,
      onlineUrl: onlineUrl,
      defaultRfqThn:
        'https://res.haizol.com/base/images/default_rfq_thumb_56_56.png',
      companyLogoUrl: companyLogoUrl,
      copyPartData: [],
      formRules: {
        num2: [
          { required: true, message: '单价不能为空', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value === null || value === undefined || value === '') {
                callback(new Error('单价不能为空'))
              } else if (isNaN(value)) {
                callback(new Error('请输入有效的数字'))
              } else if (Number(value) === 0) {
                callback(new Error('单价不能为0'))
              } else {
                const decimalPart = value.toString().split('.')[1]
                if (decimalPart && decimalPart.length > 4) {
                  callback(new Error('最多支持4位小数'))
                } else {
                  callback()
                }
              }
            },
            trigger: 'blur',
          },
        ],
      },
      partFormModel: {},
    }
  },
  filters: {
    thousands(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
  },
  methods: {
    ...mapMutations('zhenyunStore',{
      setRowTableIndex:'SET_TABLEROWINDEX'
    }),
    handleMouseEnter(row, column, cell, event) {
      const tr = cell.parentElement
      const index = Array.from(tr.parentElement.children).indexOf(tr)
      this.tableRowIndex1 = index
      // 高亮所有表格的对应行
      this.highlightAllTables(this.tableRowIndex1)
      
    },
    highlightAllTables(index) {
      this.setRowTableIndex(index)
      // 获取所有表格的body元素
      const tableBodies = document.querySelectorAll('.el-table__body')
      // 遍历所有表格
      tableBodies.forEach((body) => {
        // 移除旧的高亮
        const rows = body.querySelectorAll('.sync-highlight-row')
        rows.forEach((row) => row.classList.remove('sync-highlight-row'))
        // 添加新高亮
        if (index >= 0 && index < body.rows.length) {
          body.rows[index].classList.add('sync-highlight-row')
        }
      })
    },
    getCurrentData() {
      return this.partInfoList.map((part) => {
        return {
          ...part,
          partPriceInfoList: part.partPriceInfoList.map((info) => ({
            ...info,
          })),
        }
      })
    },
    initFormData(data) {
      this.partFormModel = { partInfoList: [...data] }
    },
    handleInputBlur(row, field, event, fixedNum) {
      const inputValue = event.target.value
      if (
        inputValue === '' ||
        inputValue === null ||
        inputValue === undefined
      ) {
        return
      }
      if (isNaN(inputValue)) {
        this.$message.error('请输入有效的数字')
        event.target.focus()
        return
      }
      const strValue = inputValue.toString()
      const [integerPart, decimalPart] = strValue.split('.')
      if (decimalPart && decimalPart.length > fixedNum) {
        this.$message.error(`最多支持${fixedNum}位小数`)
        // 直接截断，不四舍五入
        const truncatedValue = decimalPart
          ? `${integerPart}.${decimalPart.substring(0, fixedNum)}`
          : integerPart
        // 更新数据
        row[field] = parseFloat(truncatedValue)
        // 更新输入框显示
        event.target.value = truncatedValue
        event.target.focus()
      }
    },
    vaildForm() {
      return new Promise((resolve, reject) => {
        this.$refs.partFormRef.validate((valid) => {
          if (valid) {
            resolve(true)
          }
        })
      })
    },
    // 辅助函数：去掉无意义的 .00
    formatNumber(value) {
      const bigValue = value instanceof Big ? value : new Big(value)
      const isInteger = bigValue.mod(1).eq(0)
      return isInteger ? bigValue.toFixed(0) : bigValue.toFixed(2)
    },
    formatCurrency(value) {
      if (value.eq(0)) return `${this.detailInfo.symbol}0`
      const isInteger = value.mod(1).eq(0)
      const formattedNum = isInteger ? value.toFixed(2) : value.toFixed(2) // 否则保留 2 位小数

      const parts = formattedNum.split('.')
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      const finalNum = parts.join('.')
      return `${this.detailInfo.symbol}${finalNum}`
    },
    async viewDrawing(item) {
      let hashCode =
        item.attachments?.length > 0 ? item.attachments[0].hashCode : ''
      if (!hashCode) {
        return
      }
      let formData = null
      formData = new FormData()
      formData.append('encryptRfqId', this.detailInfo.rfqIdAes)
      formData.append('hashCode', hashCode)
      try {
        const { data, rspResult } = await getOnlineDrawing(formData)
        if (rspResult.bizCode === 200) {
          if (data.type == 1) {
            window.open(
              `${onlineUrl}/saas-drawing/drawing-view?folder=${
                data.target
              }&active=${hashCode}&partner=${2}&rfqQuoteId=${
                this.detailInfo.id
              }`
            )
          } else {
            window.open(`${onlineUrl}/${data.url}?active=${hashCode}&partner=${2}&rfqQuoteId=${
                this.detailInfo.id
              }`); 
            // window.open(
            //   `${data.url}?active=${hashCode}&partner=${2}&rfqQuoteId=${
            //     this.detailInfo.id
            //   }`
            // )
          }
        }
      } catch (err) {
        console.error('❌ ~ getRfqPartList ~ err:', err)
      }
    },
    transformArrayByValidFields(arr) {
      return arr
        .map((item) => {
          const validFields = []
          if (item.quoteNum1) validFields.push(item.quoteNum1)
          if (item.quoteNum2) validFields.push(item.quoteNum2)
          if (item.quoteNum3) validFields.push(item.quoteNum3)
          return validFields.length
        })
        .reduce((max, length) => Math.max(max, length), 0)
    },
    calculateTotal(arr, index, callback) {
      const rawTotal = arr.reduce((total, part) => {
        if (part.partPriceInfoList?.[index]) {
          const priceInfo = part.partPriceInfoList[index]
          return total.plus(callback(priceInfo))
        }
        return total
      }, new Big(0))
      return this.formatCurrency(rawTotal)
    },
  },
  mounted() {},
  watch: {
    partInfoList: {
      immediate: true,
      handler(val) {
        this.initFormData(val)
      },
    },
    tableRowIndex:{
      handler(newVal){
        if(newVal!==undefined){
          this.highlightAllTables(newVal)
        }
      },
    }
  },
  computed: {
    ...mapState('zhenyunStore',['tableRowIndex']),
    formatPriceTotal() {
      this.detailInfo.symbol ||= this.detailInfo.currencySymbol
      let grandTotal = new Big(0) // 所有费用的总和
      let resultArr = []
      if (this.partInfoList?.length) {
        const initialValues = this.transformArrayByValidFields(
          this.partInfoList
        )
        this.partInfoList.forEach((part, partIndex) => {
          part.partPriceInfoList.forEach((info, infoIndex) => {
            // 计算当前行的零件单价×数量（num1 * numQuantity）
            const currentUnitPriceTotal = new Big(info.numQuantity || 0).times(
              new Big(info.num1 || 0)
            )
            // 计算当前行的总费用（含模具费、杂费等）
            const currentRowTotal = currentUnitPriceTotal
              .plus(new Big(info.num2 || 0)) // num2: 模具费
              .plus(new Big(info.num3 || 0)) // num3: 杂费
              .plus(new Big(info.num4 || 0)) // num4: 运费
            grandTotal = grandTotal.plus(currentRowTotal)
            this.$set(
              this.partInfoList[partIndex]['partPriceInfoList'][infoIndex],
              'partRowTotalNumber',
              this.formatNumber(currentRowTotal)
            )
            this.$set(
              this.partInfoList[partIndex]['partPriceInfoList'][infoIndex],
              'partRowTotal',
              this.formatCurrency(currentRowTotal)
            )
          })
        })
        for (let i = 0; i < initialValues; i++) {
          resultArr[i] = {
            partTotal: this.calculateTotal(this.partInfoList, i, (info) => {
              return new Big(info.numQuantity || 0).times(
                new Big(info.num1 || 0)
              )
            }),
            mouldTotal: this.calculateTotal(
              this.partInfoList,
              i,
              (info) => new Big(info.num2 || 0)
            ),
            otherTotal: this.calculateTotal(
              this.partInfoList,
              i,
              (info) => new Big(info.num3 || 0)
            ),
            freightTotal: this.calculateTotal(
              this.partInfoList,
              i,
              (info) => new Big(info.num4 || 0)
            ),
            curQuoteTotal: this.calculateTotal(
              this.partInfoList,
              i,
              (info) => new Big(info.partRowTotalNumber || 0)
            ),
          }
        }
      }
      return resultArr
    },
  },
  beforeDestroy() {
    this.setRowTableIndex(undefined)
  },
}
</script>

<style scoped lang="scss">
/* SCSS or CSS here */
.part-table-info-item-wrapper {
  background-color: #fff;
  border-bottom: 1px solid #e9edf1;
  padding: 0 16px 16px;
  ::v-deep .el-table th.el-table__cell {
    color: #555555 !important;
    padding-top: 11px !important;
    padding-bottom: 11px !important;
    font-size: 14px;
    line-height: 22px;
    background: #e9edf1 !important;
    .cell {
      font-family: SourceHanSansCN-Regular;
    }
  }
  ::v-deep .el-table td.el-table__cell {
    color: #222222;
    font-family: SourceHanSansCN-Regular;
    font-size: 14px;
    line-height: 22px;
    padding: 8px 0px;
  }
  ::v-deep .el-input-number.is-without-controls .el-input__inner {
    text-align: left;
  }
  ::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: #FFFAF3;
  }
  ::v-deep .el-table::before{
    background-color: #fff;
  }
  .part-table-info-header {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 12px 0;
    .part-title-bold {
      color: #222222;
      font-family: SourceHanSansCN-Bold;
      font-size: 14px;
      line-height: 22px;
    }
    .unit-class {
      color: #333333;
      text-align: justify;
      font-family: SourceHanSansCN-Regular;
      font-size: 12px;
      font-style: normal;
      line-height: 22px;
    }
    .tag-list-box {
      display: flex;
      gap: 8px;
      align-items: center;
      flex-shrink: 0;
      .tag-item {
        color: #666666;
        font-family: SourceHanSansCN-Regular;
        font-size: 12px;
        padding: 3px 8px;
        border-radius: 2px;
        border: 1px solid #dcdcdc;
        // background: #f5f7fa;
      }
    }
  }
  .part-table-content-box {
    display: flex;
    gap: 16px;
    ::v-deep .el-form-item--small.el-form-item {
      margin-bottom: 0;
    }
    .quote-image {
      width: 120px;
      height: 120px;
      flex-shrink: 0;
      border-radius: 8px;
      border: 1px solid #cfd5df;
      cursor: pointer;
    }
  }
}
.flex-gap-4 {
  display: flex;
  gap: 4px;
  flex-direction: column;
}
.red-text {
  color: #ff081f;
}
</style>
<style>
.sync-highlight-row {
  background-color: #fffaf3 !important;
}
.sync-highlight-row .rowTotalClass{
  color: #FF7800 !important;
}
</style>
